import API from '~config/api';
import {
  ApiPromise,
  DataPaginateResponse,
  ErrorResponse,
} from '~globals/types';

import { CapacityTypeBase } from './types';

export const CAPACITY_TYPES_ENPOINTS = {
  getEnumCapacityTypes: '/api/v1/Enumeration/CapacityTypes',
  getCurrentCapacityTypes: '/api/v1/Route/CapacityType',
};

export const getEnumCapacityTypes = (): ApiPromise<
  DataPaginateResponse<CapacityTypeBase[]>,
  ErrorResponse
> =>
  API.get<DataPaginateResponse<CapacityTypeBase[]>, ErrorResponse>(
    CAPACITY_TYPES_ENPOINTS.getEnumCapacityTypes,
  );

export const getCurrentCapacityTypes = (): ApiPromise<
  DataPaginateResponse<CapacityTypeBase[]>,
  ErrorResponse
> =>
  API.get<DataPaginateResponse<CapacityTypeBase[]>, ErrorResponse>(
    CAPACITY_TYPES_ENPOINTS.getCurrentCapacityTypes,
  );
